import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';
import { Role, Status } from '../role';
@Injectable({ providedIn: 'root' })
class PermissionsService {

    constructor(private router: Router,
        private authService: AuthService,
        private navController: NavController
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.authService.currentUserValue;
        if (currentUser && currentUser.access_token) {
            if (route.data['permissions']) {
                // if (!route.data['acceptUnRegistUser'] && this.authService.hasRole(Role.User) && !this.authService.hasStatus(Status.Approved)) {
                //     this.router.navigate(['/not-found']);
                //     return false;
                // }
                if (!route.data['acceptUnRegistUser'] && this.authService.hasRole(Role.User) 
                        && !this.authService.isClientUser && !this.authService.isAdminUser
                        && !this.authService.hasStatus(Status.Approved)) {
                    this.router.navigate(['/not-found']);
                    return false;
                }
                const isOk = this.authService.hasPermissions(route.data['permissions']);
                if (isOk) {
                    return true;
                } else {

                    this.router.navigate(['/not-found']);
                    return false;
                }
            }
            else if (route.data['permission']) {
                // if (!route.data['acceptUnRegistUser'] && this.authService.hasRole(Role.User) && !this.authService.hasStatus(Status.Approved)) {
                //     this.router.navigate(['/not-found']);
                //     return false;
                // }
                if (!route.data['acceptUnRegistUser'] && this.authService.hasRole(Role.User) && !this.authService.isClientUser && !this.authService.isAdminUser
                      && !this.authService.hasStatus(Status.Approved)) {
                    this.router.navigate(['/not-found']);
                    return false;
                }
                const isOk = this.authService.hasPermission(route.data['permission']);
                if (isOk) {
                    // Phase 3: a route reached only to perform a CUD action (not just to view a
                    // menu) can require Write, not just any granted level — set data.requireWrite
                    // = true on that route.
                    if (route.data['requireWrite'] && !this.authService.hasWriteAccess(route.data['permission'])) {
                        this.router.navigate(['/not-found']);
                        return false;
                    }
                    return true;
                } else {
                    this.router.navigate(['/not-found']);
                    return false;
                }
            } else if (route.data['activeRoles']) {
                const isOk = this.authService.hasPermissionRoles(route.data['activeRoles']);
                if (isOk) {
                    return true;
                } else {
                    this.router.navigate(['/not-found']);
                    return false;
                }
            }
            return true;
        }

        // not logged in so redirect to login page with the return url
        this.navController.navigateRoot(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }

    // canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    //     const currentUser = this.authService.currentUserValue;
    //     if (currentUser && currentUser.access_token) {
    //         if (route.data.permission) {
    //             const isOk = this.authService.hasPermission(route.data.permission);
    //             if (isOk) {
    //                 return true;
    //             } else {
    //                 this.router.navigate(['/not-found']);
    //                 return false;
    //             }
    //         }
    //         return true;
    //     }

    //     // not logged in so redirect to login page with the return url
    //     this.navController.navigateRoot(['/login'], { queryParams: { returnUrl: state.url } });
    //     return false;
    // }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    return inject(PermissionsService).canActivate(next, state);
}